import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const withRouter = (Component) => {
  const WrappedComponent = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const url = location.pathname;

    return (
      <Component
        navigate={navigate}
        location={location}
        match={{ params, url }}
        {...props}
      />
    );
  };

  WrappedComponent.displayName = `withRouter(${Component.displayName || Component.name})`;
  WrappedComponent.propTypes = {
    Component: PropTypes.elementType.isRequired,
  };

  return WrappedComponent;
};
